import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { GeneralPhysics } from './components/GenenralPhysics'
import { KpopeNavbar } from './components/KpopeNavbar'
import AdminEditor from './components/Admin/AdminEditor'
import MFASetup from './components/Admin/MFASetup'
import LibraryCatalog from './components/GenenralPhysics/LibraryCatalog'
import SeriesPage from './components/GenenralPhysics/SeriesPage'

function App() {
  return (
    <BrowserRouter>
      <KpopeNavbar />
      <Routes>
        <Route path='/' element={<LibraryCatalog />}/>
        <Route path='/library' element={<LibraryCatalog />}/>
        <Route path='/series/:seriesName' element={<SeriesPage />}/>
        <Route path='/admin' element={<AdminEditor />}/>
        <Route path='/admin/setup' element={<MFASetup />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
